<template>
  <div>
    <div v-if="!loading" class="container">
      <div class="row">
        <div class="col-1">
          <div class="to_back">
            <router-link :to="{ name: 'Admin' }"><i class="fas fa-arrow-circle-left"></i></router-link>
          </div>
        </div>
        <div class="col-8 m-auto">
          <div class="userEdit">
            <div class="userEdit_item">
              <h3>Редактирование пользователя - <span>{{ user.first_name }}</span>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="user.is_active" id="flexCheckDefault">
                  <label class="form-check-label" for="flexCheckDefault">
                    Активный
                  </label>
                </div>
              </h3>
              <div class="input_group">
                <div class="input_block">
                  <p>Имя</p>
                  <input type="text" v-model="user.first_name" :disabled="!isAvailable(['admin'])">
                </div>
                <div class="input_block">
                  <p>Почта</p>
                  <input type="text" v-model="user.email" :disabled="!isAvailable(['admin'])">
                </div>
                <div class="input_block">
                  <p>Номер телефона</p>
                  <input type="text" v-model="user.phone">
                </div>
                <div class="input_block">
                  <p>Баланс</p>
                  <input type="number" v-model.number="user.deposit">
                </div>

                <div class="input_block" v-if="isAvailable(['admin', 'welder'])">
                  <label class="typo__label">Доп. параметры фильтрации по партнерам</label>
                  <multiselect v-model="user.partners " :options="partners" :multiple="true" :close-on-select="false"
                              :clear-on-select="false" :preserve-search="true" placeholder="Выбрать"
                              :preselect-first="true" label="value" track-by="value" :show-labels="false">
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.value }}</span>
                      </div>
                    </template>
                  </multiselect>

                </div>
                <div class="input_block" v-if="isAvailable(['admin', 'welder'])">
                  <label class="typo__label">Роли пользователя</label>
                  <multiselect v-model="role" :options="getUserRoles"
                              :clear-on-select="false" :preserve-search="true" placeholder="Выбрать"
                              :preselect-first="false" label="role_name" track-by="id" :show-labels="false">
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.role_name }}</span>
                      </div>
                    </template>
                  </multiselect>

                </div>
                <div class="input_block" v-if="isAvailable(['admin', 'welder'])">
                  <label class="typo__label">Город</label>
                  <multiselect
                    v-model="user.cities"

                    :options="editOptions.cities"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :show-labels="false"

                    placeholder="Выбрать"

                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option }}</span>
                      </div>
                    </template>
                  </multiselect>

                </div>
                <div class="input_block" v-if="isAvailable(['admin', 'welder'])">
                  <label class="typo__label">Вид работ</label>
                  <multiselect
                    v-model="user.tows"

                    :options="editOptions.tows"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :show-labels="false"

                    label="tow"
                    placeholder="Выбрать"
                    track-by="id"
                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.tow }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <div class="input_block">
                  <p>Телеграм:</p>
                  <input type="text" v-model="user.tg" placeholder="ChatId" :disabled="!isAvailable(['admin'])">
                </div>

                <div class="input_block">
                  <p>CRM:</p>
                  <input type="text" v-model="user.crm" placeholder="поддомен | юзер | пасс" :disabled="!isAvailable(['admin'])">
                </div>

              </div>

              <div class="input_block_full">
                <span @click="updateUser" class="btn btn-primary">Сохранить</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container4">
      <pulse-loader :loading="loading" :color="color" :size="size" class="loader"></pulse-loader>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import api from "@/services/api";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axiosInstance from "../services/api.js"

export default {
  name: "Account",
  components: {
    'multiselect': Multiselect,
    'pulse-loader': PulseLoader
  },

  data: () => {
    return {
      color: "#2c3e50",
      size: "20px",
      loading: false,
      partners: [],
      user: {
        first_name: '',
        email: '',
        phone: '',
        is_active: false,
        deposit: 0,

        partners: [],
        city: [],
        tows: [],
        tg: '',
        crm: '',
      },
      role: [],

      editOptions: {
        partners: [],
        roles: [],
        cities: [
          {
            id: 0,
            city: 'Moscow',
          },
        ],
        tows: [
          {
            id: 0,
            name: 'Пластиковые окна',
          },
        ],
      }
    }
  },

  computed: {
    ...mapGetters(['getEditUser', 'getUserRoles', 'meRoles'])
  },

  async created() {
    this.loading = true
    await this.getAdminUser(this.$route.params.id)
    await this.getAdminRole()

    this.user = this.getEditUser.user
    this.role = this.getEditUser.roles
    this.partners = await this.getParams('partner_id')
    await this.partnersMap()

    this.loadUserSelectorsData();

    this.loading = false
  },

  methods: {
    ...mapActions([
      'getAdminUser',
      'getAdminRole',
      'updateAdminUser',
      'updateAdminUserRole',
      'delRolAdminUser',
    ]),
    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    },
    async getParams(column) {
      try {
        const res = await api.get('/params/' + column)
        return res.data
      } catch (e) {
        console.log(e)
      }

    },
    async partnersMap() {
      if (this.partners.length > 0) {

        if (this.user.partners) {
          this.user.partners = this.user.partners.map((item) => {
            return {
              value: item,
              key: 'partner_id'
            }
          })
        }

      } else {
        this.user.partners = []
      }

    },
    async updateUser() {
      this.loading = true

      const userRole = Array.isArray(this.role) ? this.role[0] : this.role;

      this.updateAdminUser(this.user)
      this.updateAdminUserRole([
        {
          user_id: this.user.id,
          roles_id: userRole.id
        }
      ])
      this.partnersMap()
      this.loading = false

    },

    async loadUserSelectorsData () {
      axiosInstance.get('/api/userdata').then((res) => {
        this.editOptions.tows = res.data.tows;
        this.editOptions.cities = res.data.cities;
      })
      .catch(() => {
        Vue.alert("Попробуйте перезагрузить страницу, если проблема не решилась, то на сервере ведутся тех. работы", "Ошибка при загрузке селекторов", "error", {
          reverseButtons: true
        })
      })
    },
  },

  watch: {
    role(val, oldVal) {
      //
      if (Array.isArray(val)) {
        val = val[0];
      }

      if (Array.isArray(oldVal)) {
        oldVal = oldVal[0];
      }

      if (!oldVal || !oldVal.id) {
        return;
      }

      if (val !== oldVal) {
        this.delRolAdminUser({
          id: this.user.id,
          role_id: oldVal.id
        })
      }

    }
  }
}
</script>

<style scoped>
.to_back {
  padding: 10px;
  margin-top: 50px;
  border-radius: 10px;

  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s ease;
}

.to_back:hover {
  box-shadow: 0 8px 6px 0 rgb(32 33 37 / 10%);
}

.to_back i {
  cursor: pointer;
  font-size: 24px;
  color: #333;
}

.userEdit {
  padding: 20px;
  margin-top: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border: 1px solid #ddd;
}

.userEdit h3 {
  border-bottom: 1px dashed #ccc;
  color: #333;
  font-size: 24px;
  font-weight: 500;
  position: relative;
}

.userEdit h3 span {
  font-weight: 600;
}

.userEdit h3 .form-check {
  font-size: 14px;
  position: absolute;
  top: 7px;
  right: 0;
}

.userEdit h3 .form-check input {
  margin-top: 0;
}

.userEdit .userEdit_item {
  margin-bottom: 20px;
}

.input_group {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

.input_block {
  width: 49%;
  margin: 10px 0;
  display: inline-block;
  padding-right: 15px;
}



.input_block_full {
  width: 100%;
}

.input_block_full span.btn {
  margin-left: 0 !important;
  width: 100% !important;
  margin-bottom: 20px;
  margin-top: 15px;
}

.input_block input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
  padding: 7px 10px;
  font-size: 14px;
}

.input_block p {
  margin-bottom: 5px;
  font-size: 14px;
}

.userEdit .userEdit_item span {
  width: 200px;
  border-radius: 10px;
  margin-bottom: 0px;
  margin-left: 15px;
}

.typo__label {
  margin-bottom: 0.5em;
}

div.container4 {
  height: 10em;
  position: relative
}

.loader {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%)
}

</style>
